<template>
  <v-container>
    <v-card outlined v-for="release in releaseNotesCards" :key="release.name" class="my-2">
      <v-card class="d-flex pb-1" flat>
        <v-card flat width="160">
          <v-card-title>{{ release.name }}</v-card-title>
          <v-card-subtitle>{{ timeFrom(release.date) }} ago</v-card-subtitle>
        </v-card>
        <v-divider vertical inset class="mx-4"></v-divider>
        <v-card-text class="pa-0 mb-2">
          <div v-html="release.html" class="markdown"></div>
        </v-card-text>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import { makeFindMixin } from "feathers-vuex";
import { DateTime } from "luxon";
import plur from "plur";
import MarkdownIt from "markdown-it";

const md = new MarkdownIt();

export default {
  name: "ReleasesPage",
  components: {},
  mixins: [
    makeFindMixin({
      service: "release-notes/app",
      name: "release-notes",
    }),
  ],
  props: {},
  data() {
    return {};
  },
  computed: {
    releaseNotesParams() {
      return {};
    },
    releaseNotesCards() {
      return this.releaseNotes
        .filter((v) => !v.name.includes("v3"))
        .map((v) => ({
          ...v,
          html: md.render(v.release && v.release.description ? v.release.description : ""),
        }));
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    timeFrom(date) {
      if (!date) {
        return "";
      }
      const diff = DateTime.fromISO(date).diffNow();
      let n = 0;
      if (Math.abs(diff.as("days")) > 365) {
        n = Math.floor(Math.abs(diff.as("years")));
        return `${n} ${plur("year", n)}`;
      }
      if (Math.abs(diff.as("days")) > 31) {
        n = Math.floor(Math.abs(diff.as("months")));
        return `${n} ${plur("month", n)}`;
      }
      n = Math.floor(Math.abs(diff.as("days")));
      return `${n} ${plur("day", n)}`;
    },
  },
};
</script>

<style>
.markdown > h1 {
  font-size: 1.75em;
  font-weight: 600;
  margin: 24px 0 16px;
  padding-bottom: 0.3em;
  border-bottom: 1px solid #eaeaea;
  color: #303030;
}
.markdown > h2 {
  font-size: 1.5em;
  font-weight: 600;
  margin: 24px 0 16px;
  padding-bottom: 0.3em;
  border-bottom: 1px solid #eaeaea;
  color: #303030;
}
</style>
